import React, { useCallback, useState } from "react";
import AccessGate from "./components/AccessGate";
import ProgressHeader from "./components/ProgressHeader";
import FeatureCard from "./components/FeatureCard";
import { useChecklistProgress } from "./hooks/useChecklistProgress";
import "./PreDeployChecklistPage.css";

const isAlreadyUnlocked = () =>
  sessionStorage.getItem("myrep_predeploy_unlocked") === "true";

const PreDeployChecklistPage: React.FC = () => {
  const [unlocked, setUnlocked] = useState(isAlreadyUnlocked);
  const { checked, toggleItem, resetAll, checkedCount, totalItems, sections } =
    useChecklistProgress();

  const handleUnlock = useCallback(() => setUnlocked(true), []);

  const handleReset = useCallback(() => {
    if (window.confirm("Clear all checked items on this device?")) {
      resetAll();
    }
  }, [resetAll]);

  if (!unlocked) {
    return <AccessGate onUnlock={handleUnlock} />;
  }

  return (
    <div className="pre-deploy-checklist-page">
      <ProgressHeader
        checkedCount={checkedCount}
        totalItems={totalItems}
        onReset={handleReset}
      />
      <div className="pre-deploy-checklist-page__content">
        <p className="pre-deploy-checklist-page__intro">
          Everything below shipped to staging since the last production
          release. Work through each feature and check off a step once
          you&apos;ve confirmed it works as described — your progress is
          saved automatically in this browser.
        </p>
        {sections.map((section) => (
          <div key={section.id} className="pre-deploy-checklist-page__section">
            <p className="pre-deploy-checklist-page__section-title">
              {section.title}
            </p>
            <div className="pre-deploy-checklist-page__cards">
              {section.features.map((feature) => (
                <FeatureCard
                  key={feature.id}
                  feature={feature}
                  checked={checked}
                  onToggleItem={toggleItem}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PreDeployChecklistPage;
